import {Component, Input, input, OnInit, output} from '@angular/core';
import {visitReason} from '@employee-pages/shared/components/fields-for-forms/visit-reason/visit-reason.model';
import {UIComponentsModule} from '@ui-app/app.module';
import {BaseFieldComponent} from '@employee-pages/shared/components/fields-for-forms/base-field.component';

interface IReasons {
    name: string;
    id: number;
}

@Component({
    selector: 'employee-visit-reason',
    standalone: true,
    imports: [
        UIComponentsModule
    ],
    templateUrl: './visit-reason.component.html',
    styleUrl: './visit-reason.component.less'
})
export class VisitReasonComponent extends BaseFieldComponent implements OnInit {
    controlKey = input('visitReasonId');
    disabled = input(false);
    visitReasonChange = output<string>();
    @Input() reasons: IReasons[] = visitReason;

    protected onSelectionChange(value: string): void {
        const reasonId = this.reasons.find(item => item.name === value).id;
        this.parentForm.patchValue({
            [this.controlKey()]: reasonId,
        });
        this.visitReasonChange.emit(value);

    }

    protected initControl(): void {
        this.selectedValue = this.reasons.find(item => item.id === this.defaultValue)?.name;
        super.initControl();
    }
}
